var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.pc)?_c('div',[(_vm.is_display)?_c('topcomponents'):_vm._e(),_vm._v(" "),(_vm.is_display)?_c('main',{staticStyle:{"position":"relative","background":"#F6FAFF","min-width":"1200px","min-height":"calc(100vh - 321px)"}},[_c('router-view')],1):_c('main',[_c('router-view')],1),_vm._v(" "),(_vm.is_display)?_c('webBottomcomponents'):_vm._e()],1):_c('div')])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4def358a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 